const REDEMPTION_CHANNELS = {
  online:"Online",
  inStore:"InStore",
  SelfRedemption:"SelfRedemption",
  onlineAndInStore:"OnlineAndInStore"
} as const;

type RedemptionChannel = ValueOf<typeof REDEMPTION_CHANNELS>;

export { REDEMPTION_CHANNELS };
export type { RedemptionChannel };
